import { onReady } from "#public/utils/on-ready.js";

const setCurrentTheme = (themeName) =>
  localStorage.setItem("theme_name", themeName);

const applyTheme = (themeName) => {
  if (themeName === "default") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", themeName);
  }
};

const updateButtonText = (themeName) => {
  const computed = getComputedStyle(document.documentElement);
  const displayName = computed
    .getPropertyValue(`--theme-${themeName}-name`)
    .trim();
  const resolvedDisplayName = displayName
    ? displayName.replace(/['"]/g, "")
    : themeName;

  document
    .getElementById("theme-switcher-button")
    ?.setAttribute(
      "aria-label",
      `Current theme: ${resolvedDisplayName}. Click to switch theme`,
    );
};

const cycleTheme = () => {
  const computed = getComputedStyle(document.documentElement);
  const themeListStr = computed.getPropertyValue("--theme-list").trim();
  const themes = themeListStr
    ? themeListStr.replace(/['"]/g, "").split(",")
    : ["default"];

  const currentTheme = localStorage.getItem("theme_name") || "default";

  const currentIndex = themes.indexOf(currentTheme);
  const nextIndex = (currentIndex + 1) % themes.length;
  const nextTheme = themes[nextIndex];

  setCurrentTheme(nextTheme);
  applyTheme(nextTheme);
  updateButtonText(nextTheme);
};

const initThemeSwitcher = () => {
  const button = document.getElementById("theme-switcher-button");
  if (!button) return;
  if (window.location.pathname.includes("/theme-editor/")) {
    // Hide button and reset theme on theme-editor page
    button.style.display = "none";
    setCurrentTheme("default");
    applyTheme("default");
  } else {
    // Show button on other pages
    button.style.display = "";
    const currentTheme = localStorage.getItem("theme_name") || "default";
    applyTheme(currentTheme);
    updateButtonText(currentTheme);
    button.addEventListener("click", cycleTheme);
  }
};

onReady(initThemeSwitcher);
